export const ERROR_CODE = {
    EMAIL_EXISTED: 4106,
    USER_NOT_FOUND: 4101
}